exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".HelpSectionMobile__container___2jbL9 > div:not(:last-child) {\n  margin-bottom: 16px; }\n\n.HelpSectionMobile__container___2jbL9 .HelpSectionMobile__externalLink___2bbIe {\n  color: rgba(0, 0, 0, 0.5);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 21px;\n  opacity: 65%; }\n  .HelpSectionMobile__container___2jbL9 .HelpSectionMobile__externalLink___2bbIe:hover {\n    color: #f94144; }\n", ""]);

// exports
exports.locals = {
	"container": "HelpSectionMobile__container___2jbL9",
	"externalLink": "HelpSectionMobile__externalLink___2bbIe"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/Footer/HelpSectionMobile/HelpSectionMobile.scss
// module id = 2093
// module chunks = 6